import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import {descricaoSituacao} from './documentoInscricao.js';

const useStyles = makeStyles(theme => ({
    chip: {
        fontWeight: 500,
        color: theme.palette.common.white
    },
    APROVADO: {backgroundColor: theme.palette.quinary.main},
    NEGADO: {backgroundColor: theme.palette.error.main},
    PARA_ANALISAR: {
        backgroundColor: theme.palette.senary.main,
        color: theme.palette.text.primary
    },
    NAO_SALVO: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.primary
    }
}));

/* Situação do documento da inscrição como etiqueta colorida (mesmo padrão do StatusSituacaoInscricao). */
export default function StatusDocumentoInscricao({situacao}) {
    const classes = useStyles();

    if (!situacao) {
        return null;
    }

    return (
        <Chip size='small' label={descricaoSituacao(situacao)} className={clsx(classes.chip, classes[situacao])}/>
    );
}

StatusDocumentoInscricao.propTypes = {
    situacao: PropTypes.oneOf(['APROVADO', 'NEGADO', 'PARA_ANALISAR', 'NAO_SALVO'])
};
